import { Flex, Image, Text } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import StreamGoldIcon from '../../assets/store/StreamGold.png';
import { AuthenticatedComponent } from '../../auth/keycloak';
import PageDataContext from '../../context/PageDataContext';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { getUserInventory, InventoryDef } from '../../service/inventory';

interface CurrencyProps {
    refreshFlag: boolean | undefined;
    quantityCallback: (total: number) => void;
}

export const Currency: AuthenticatedComponent<CurrencyProps> = ({
    keycloak,
    refreshFlag,
    quantityCallback,
}) => {
    const { isLoadFromCache } = useContext(PageDataContext);
    const [balanceTotal, setBalanceTotal] = useSessionStorage<number>(
        'streamgold_balance_total',
        0,
    );
    const [refItem, setReferenceItem] = useSessionStorage<InventoryDef | undefined>(
        'streamgold_ref_item',
        undefined,
    );

    const getInventory = async () => {
        try {
            const invs = await getUserInventory(
                keycloak.subject,
                'streamsix_currency',
                '',
                keycloak.token,
            );

            let total = 0;
            invs.forEach((inv) => {
                setReferenceItem(inv);
                total += inv.quantity;
            });
            setBalanceTotal(total);
            quantityCallback(total);
        } catch (err: any) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!isLoadFromCache) {
            getInventory();
        }
    }, []);

    useEffect(() => {
        console.log(`trigger refreshFlag ${refreshFlag}`);
        refreshFlag = false;
        getInventory();
    }, [refreshFlag]);

    return (
        <Flex className={'currency'}>
            {refItem !== undefined ? (
                <Flex className={'full-wallet'}>
                    <Image src={StreamGoldIcon} />
                    <Text>{`${balanceTotal} ${refItem?.inventory_item.item_name}`}</Text>
                </Flex>
            ) : (
                <Text className={'empty-wallet'}>Your wallet is empty!</Text>
            )}
        </Flex>
    );
};
